(function () {
  var menu = document.getElementById('menu');
  var openBtn = document.getElementById('open-menu');
  var closeBtn = document.getElementById('close-menu');

  function openMenu() {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }
  openBtn.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Close the menu whenever a route link is clicked
  document.querySelectorAll('[data-route]').forEach(function (a) {
    a.addEventListener('click', function () { closeMenu(); });
  });

  // ── Hash routing ──
  var pages = document.querySelectorAll('.page');
  function showPage(name) {
    var found = false;
    pages.forEach(function (p) {
      if (p.dataset.page === name) { p.classList.add('is-active'); found = true; }
      else p.classList.remove('is-active');
    });
    if (!found) {
      document.querySelector('.page[data-page="home"]').classList.add('is-active');
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }
  function route() {
    var h = (location.hash || '#/').replace(/^#\//, '').replace(/^#/, '');
    if (!h) h = 'home';
    showPage(h);
  }
  window.addEventListener('hashchange', route);
  route();

  // ── Tweaks ──
  var TWEAKS = /*EDITMODE-BEGIN*/{
    "badgeText": "bestseller",
    "badgeOn": "01"
  }/*EDITMODE-END*/;

  var panel = document.getElementById('tweaks');
  var twText = document.getElementById('tw-text');
  var twSeg = document.getElementById('tw-seg');
  var twClose = document.getElementById('tweaks-close');

  function applyTweaks() {
    document.querySelectorAll('[data-product]').forEach(function (card) {
      var badge = card.querySelector('.card__badge');
      if (!badge) return;
      badge.textContent = TWEAKS.badgeText || '';
      badge.hidden = !(TWEAKS.badgeOn && card.dataset.product === TWEAKS.badgeOn);
    });
    twText.value = TWEAKS.badgeText;
    twSeg.querySelectorAll('button').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.val === TWEAKS.badgeOn);
    });
  }
  applyTweaks();

  function persist(edits) {
    Object.assign(TWEAKS, edits);
    applyTweaks();
    try {
      window.parent.postMessage({ type: '__edit_mode_set_keys', edits: edits }, '*');
    } catch (e) {}
  }

  twText.addEventListener('input', function () { persist({ badgeText: twText.value }); });
  twSeg.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-val]');
    if (!b) return;
    persist({ badgeOn: b.dataset.val });
  });

  function openTweaks() { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); }
  function closeTweaks() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    try { window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*'); } catch (e) {}
  }
  twClose.addEventListener('click', closeTweaks);

  // Register listener BEFORE announcing availability
  window.addEventListener('message', function (e) {
    var d = e.data || {};
    if (d.type === '__activate_edit_mode') openTweaks();
    else if (d.type === '__deactivate_edit_mode') closeTweaks();
  });
  try { window.parent.postMessage({ type: '__edit_mode_available' }, '*'); } catch (e) {}
})();